module.exports = __webpack_public_path__ + "static/media/lideranca.13a9dae6.svg";